/*
 * @LastEditors: ttheitao
 * @Description: 基础设置
 * @FilePath: \onetab\src\store\settings.ts
 * @Date: 2024-03-19 18:09:01
 * @LastEditTime: 2024-04-12 15:01:08
 * @Author: lisushuang
 */

import Database from "@/lib/Database";
import { reactive, watch } from "vue";

export enum showType {
  AlwaysShow,
  AutoHide,
  AlwaysHide,
}

export enum sidePosition {
  Left,
  Right,
}

export const settings = reactive({
  // control column
  sideColumn: <showType>showType.AlwaysShow,
  sideColumnPosition: <sidePosition>sidePosition.Left,
  bottomColumn: <showType>showType.AlwaysShow,

  // bookmarks
  newBookmark: true,
  bookmarkWidth: 80,
  hideNewBookmark: false,
  hideBookmarkName: false,
  bookmarksConfig:['showIcon','showName'],

  // search input
  searchWidth: 100,
  searchOpacity: 100,
  searchConfig:['searchSuggestion','保留搜索框内容'],
  searchOpenNew: true,
  defaultFont:true,
  theme:'light',
  searchEngines:['baidu','bing','google'],
  wallpaper:'',
  isSimple:false
});

watch(settings, (newValue) => {
  if(Database.db){
    const logStore = Database.db
    .transaction(Database.storeNames.logs, 'readwrite')
    .objectStore(Database.storeNames.logs);
    const param=JSON.parse(JSON.stringify(newValue))
    localStorage.setItem('onetab_settings',JSON.stringify(param))
    logStore.put({ type: 'settings', ...param });
  }
});